import React from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { Tag } from 'primereact/tag';
import { FormField } from '../../FormField/FormField';
import { ROUTINE_TYPES } from '../../../types/Fisiofit/routine';
import { ROUTINE_TYPE_OPTIONS } from '../constants';
import { RoutineFormFieldProps } from '../types';

type RoutineTypeFieldProps = Pick<RoutineFormFieldProps, 'form' | 'setFormFields'> & {
  isCreating: boolean;
  isNextRoutine: boolean;
  isEditing: boolean;
  creatingFromUserProfile: boolean;
  creatingNewRoutineForExpired: boolean;
};

export const RoutineTypeField = ({
  form,
  setFormFields,
  isCreating,
  isNextRoutine,
  isEditing,
  creatingFromUserProfile,
  creatingNewRoutineForExpired,
}: RoutineTypeFieldProps) => {
  return (
    <FormField elementId='routineType' labelTitle='Tipo de rutina' fullWidth>
      {isCreating && !isNextRoutine && !isEditing && !creatingFromUserProfile && !creatingNewRoutineForExpired ? (
        <SelectButton
          id='routineType'
          value={form?.routineType}
          options={ROUTINE_TYPE_OPTIONS}
          onChange={(e) => setFormFields({ routineType: e.value, name: undefined, externalUser: undefined })}
          disabled={isEditing}
        />
      ) : (
        <Tag
          value={form?.routineType === ROUTINE_TYPES.USER ? 'Rutina de usuario' : 'Plantilla'}
          {...(form?.routineType === ROUTINE_TYPES.USER ? {} : { severity: 'contrast' })}
        />
      )}
    </FormField>
  );
};
